import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Card, CardBody, Container, Button, Spinner } from 'reactstrap';
import useGet from '../../helpers/hooks/useGet';
import usePatch from '../../helpers/hooks/usePatch';
import usePost from '../../helpers/hooks/usePost';
import { AddCity } from './add-city';

import { CitiesList } from './cities-list';

export const Cities = (props) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [cities, , citiesLoading, loadCities] = useGet(
    '/cities?filter[order]=createdAt DESC&filter[include][0][relation]=district',
    true
  );
  const [postData, postedData, postingError, dataPosting] = usePost('/cities');
  const [updateData, updatedData, updatingError, dataUpdating] = usePatch('');
  const handleAddNewDistrict = (event, errors, values) => {
    console.log(values, errors);
    if (errors.length === 0) {
      postData({ ...values });
    }
  };
  const handleDistrictPatch = (id, data) => {
    updateData(data, `/cities/${id}`);
  };
  useEffect(() => {
    if (postedData) {
      setShowAddForm(false);
      loadCities();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postedData]);
  useEffect(() => {
    if (updatedData) {
      loadCities();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Cities</h4>
            {/* <Button
              color='primary'
              onClick={() => setShowAddForm(!showAddForm)}
            >
              Add New City
            </Button> */}
          </div>
          {showAddForm && (
            <AddCity onAdd={handleAddNewDistrict} disabled={dataPosting} />
          )}
          <Card>
            <CardBody>
              {citiesLoading || dataUpdating ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <CitiesList
                  onUpdate={handleDistrictPatch}
                  data={cities?.map((x, i) => ({
                    ...x,
                    srNo: i + 1,
                    createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
                    updatedAt: dayjs(x.updatedAt).format('DD/MM/YYYY'),
                    actions: (
                      <Link to={`/cities-details/${x.id}`}> 
                      <Button color='primary' >Edit</Button>
                      </Link>
                    )
                  }))}
                />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};
